
import React from 'react';
import { Container, Row } from "react-bootstrap";
import PropTypes from 'prop-types';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import { ExpansionPanel, ExpansionPanelDetails, ExpansionPanelSummary } from '@material-ui/core';
import { makeStyles } from "@material-ui/core/styles";
import './BusinessSolutionsAbout.scss';

const useStyles = makeStyles(theme => ({
  textcolor: {
    color: theme.palette.primary.main,
  }
}));
export default function About(props) {
  const classes = useStyles();
  const { data } = props;

  return (
    <Container fluid className='business-solutions-about' id="business-solutions">
      <Row className="justify-content-center">
        <h2 className="text-center about-title mb-3">{data.title}</h2>
      </Row>
      <Row className="justify-content-center">
        <p className='about-content'>{data.content}</p>
      </Row>
    </Container>
  );
};

About.propTypes = {
  title: PropTypes.string,
  content: PropTypes.string,
};



// WEBPACK FOOTER //
// ./src/components/LandingPages/About/BusinessSolutionsAbout.js